'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi4Bar = function DeviceSignalWifi4Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
  );
};
DeviceSignalWifi4Bar = (0, _pure2.default)(DeviceSignalWifi4Bar);
DeviceSignalWifi4Bar.displayName = 'DeviceSignalWifi4Bar';
DeviceSignalWifi4Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi4Bar;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/device/signal-wifi-4-bar.js
 ** module id = 1882
 ** module chunks = 0
 **/